// Globals
import { useTranslation } from 'react-i18next';

// Components
import { TrashIcon } from '@/icons';
import { Button } from '@/ui';
import { StyledButton, StyledButtonWrapper, StyledImage, StyledImageCard, StyledModal } from './ImageCardStyles';

// Models
import { IFile } from '@/models/file.model';

// Helpers
import { useBoolean } from '@/hooks';

type TImageCard = {
  image: IFile;
  onDelete?: (file: IFile) => void;
};

const ImageCard = ({ image, onDelete }: TImageCard) => {
  const handleDelete = () => onDelete?.(image);
  const { t } = useTranslation('common');
  const { value: isModalOpen, setTrue: openModal, setFalse: closeModal } = useBoolean(false);

  return (
    <>
      <StyledImageCard>
        <StyledImage
          src={image.link}
          alt={image.name}
          preview={{
            toolbarRender: () => null,
          }}
        />
        {onDelete && <StyledButton type="primary" danger onClick={openModal} icon={<TrashIcon />} />}
      </StyledImageCard>
      <StyledModal open={isModalOpen} onCancel={closeModal} title={t('delete_photo_title')}>
        <p>{t('delete_photo_message')}</p>
        <StyledButtonWrapper>
          <Button type="default" block shape="round" onClick={closeModal}>
            {t('delete_photo_cancel')}
          </Button>
          <Button danger block shape="round" onClick={handleDelete}>
            {t('delete_photo')}
          </Button>
        </StyledButtonWrapper>
      </StyledModal>
    </>
  );
};

export default ImageCard;
